import * as Yup from "yup";

export const homeBannerValidation = Yup.object().shape({
  // title: Yup.string().required("Title is required"),
  banner: Yup.string().required("Banner is required"),
  mobileBanner:Yup.string().required("Mobile Banner is required"),
  colorText: Yup.mixed().required("Colored Text is required"),
});
